import HeadingTitle from "../headingTitle/HeadingTitle";
import "./FoodRecipe.scss";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPosts } from "../../redux/features/post/postSlice";
import { Link } from "react-router-dom";

import DOMPurify from "dompurify";
import { shortenText } from "../../utils";
const FoodRecipe = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const { posts } = useSelector((state) => state?.post);

  const foodAndRecipe = posts
    ?.filter((food) => {
      return food?.category === "Food";
    })
    ?.filter((food, index) => index < 3);

  return (
    <div className="foodRecipe">
      <HeadingTitle title="Food &amp; Recipe" />
      <div className="foodRecipeWrapper">
        {foodAndRecipe?.map((food) => {
          return (
            <div className="itemLeft" key={food._id}>
              <div className="boxOption">
                <div className="boxOptionWrapper">
                  <div className="item">
                    <Link to={`/page/${food._id}`}>
                      <img src={food?.image} alt="" />
                    </Link>
                    <div className="postInfo">
                      <ul className="nav">
                        <li>{food?.author}</li>
                      </ul>
                      <Link to={`/page/${food._id}`}>
                        <h3
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              shortenText(food?.title, 90)
                            ),
                          }}
                        ></h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="itemRight">
          <div className="itemRightWrapper">
            <div className="advert1">
              <Link>
                <img src="assets/ad-150x150-1.jpg" alt="" />
              </Link>
            </div>
            <div className="advert2">
              <Link>
                <img src="assets/ad-150x150-2.jpg" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FoodRecipe;
